import BadRequestHttpError from "../BadRequestHttpError";
import ITokenExpiredHttpErrorResponse from "../../interfaces/BadRequest/ITokenExpiredHttpErrorResponse";

export default class TokenExpiredHttpError extends BadRequestHttpError<ITokenExpiredHttpErrorResponse> {
    constructor(response: ITokenExpiredHttpErrorResponse) {
        super("Token expired!", response);
    }
}
